import { HOST_URL } from "../../config/constants";
import { createSitemap } from "../../helpers/createSitemap";

const PagesSitemap = () => <></>;

export async function getServerSideProps({ res, req }) {
  const apiPrivateUrl = process.env.apiPrivateUrl;

  try {
    const apiEndpoints = [`${apiPrivateUrl}/sitemap/pages`];

    const [channelsData] = await Promise.all(
      apiEndpoints.map((endpoint) =>
        fetch(endpoint)
          .then((response) => response.json())
          .catch((err) => console.log(err))
      )
    );

    res.setHeader("Content-Type", "text/xml");
    res.write(createSitemap(HOST_URL, channelsData, 0.6));
    res.end();
    return { props: {} };
  } catch (e) {}

  return { notFound: true };
}

export default PagesSitemap;
